@if (showSpinner && !loadview) {
  <div class="overlay">
    <div cbPageSpinner colorTheme="default" sizeVariant="large">
      <p-progressSpinner></p-progressSpinner>
    </div>
  </div>
}
@if (loadview && !showSpinner) {
  <div>
    @if (pageData.banner) {
      <div>
        <app-marketing-banner
          [bannerbgColor] = "pageData.banner.backgroundcolor"
          [imagePath]= "pageData.banner.image"
          [policyTitle]="pageData.banner.productName"
          [policyInfo]="pageData.banner.bannerInfo"
          [coverageadviserimg] = "pageData.banner.coverageadviserimg"
          [coverageadviserlink] = "pageData.banner.coverageadviserlink"
          [buttoninfo] = "pageData.banner.buttoninfo"
        ></app-marketing-banner>
      </div>
    }
    @if (pageData.protectData) {
      <div class="whitebackgound">
        <app-marketing-product-info
          [protectTitle]="pageData.protectData.protectTitle"
          [productDesc] ="pageData.protectData.protectDecs"
          [protectArrItems]="pageData.protectData.protectArr"
        ></app-marketing-product-info>
      </div>
    }
    @if (pageData.tabdata) {
      <div class="whitebackgound">
        <app-marketing-tabs
          [tabTitle]="pageData.tabdata.tabTitle"
          [tabs]="pageData.tabdata.tabItems"
          [disclaimer]="pageData.tabdata.disclaimer"
        ></app-marketing-tabs>
      </div>
    }
    @if (pageData.coverageData) {
      <div class="otherbackgound">
        <app-marketing-coverage
          [coverageTitle]="pageData.coverageData.coverageTitle"
          [coverageDescription]="pageData.coverageData.coverageDescription"
          [coveredItems]="pageData.coverageData.coveredItems"
          [notCoveredItems]="pageData.coverageData.notCoveredItems"
          [endorsementItems]="pageData.coverageData.endorsementItems"
          [ProductName]="pageData.banner.productName"
        ></app-marketing-coverage>
      </div>
    }
    @if (pageData.productstep) {
      <div class="whitebackgound">
        <app-marketing-product-steps
          [stepTitle]="pageData.productstep.stepSectionTitle"
          [stepMessage]="pageData.productstep.stepSectionMessage"
          [steps]="pageData.productstep.stepsArr"
        ></app-marketing-product-steps>
      </div>
    }
  </div>
}

